import { render, staticRenderFns } from "./TitleWithIcon.vue?vue&type=template&id=63d3d3c2"
import script from "./TitleWithIcon.vue?vue&type=script&lang=js"
export * from "./TitleWithIcon.vue?vue&type=script&lang=js"
import style0 from "./TitleWithIcon.vue?vue&type=style&index=0&id=63d3d3c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports